'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _UIClickable = require('./UIClickable');

var _UIClickable2 = _interopRequireDefault(_UIClickable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var SIZE_CLASSES = {
  small: 'private-close__icon--sm',
  medium: 'private-close__icon--md',
  large: '',
  'extra-large': 'private-close__icon--xl'
};

exports.default = _react2.default.createClass({
  displayName: 'UICloseButton',

  propTypes: {
    className: _react.PropTypes.string,
    color: _react.PropTypes.string,
    disabled: _react.PropTypes.bool.isRequired,
    onClick: _react.PropTypes.func.isRequired,
    size: _react.PropTypes.oneOf(Object.keys(SIZE_CLASSES)),
    style: _react.PropTypes.object
  },

  getDefaultProps: function getDefaultProps() {
    return {
      disabled: false,
      size: 'large'
    };
  },
  renderCloseIcon: function renderCloseIcon() {
    return _react2.default.createElement(
      'svg',
      {
        className: 'private-close__icon',
        viewBox: '0 0 14 14',
        xmlns: 'http://www.w3.org/2000/svg' },
      _react2.default.createElement('path', { className: 'private-close__icon__inner',
        d: 'M14.5,1.5l-13,13m0-13,13,13',
        transform: 'translate(-1 -1)'
      })
    );
  },
  render: function render() {
    var _props = this.props,
        className = _props.className,
        color = _props.color,
        disabled = _props.disabled,
        onClick = _props.onClick,
        size = _props.size,
        style = _props.style,
        rest = _objectWithoutProperties(_props, ['className', 'color', 'disabled', 'onClick', 'size', 'style']);

    return _react2.default.createElement(
      _UIClickable2.default,
      _extends({}, rest, {
        className: (0, _reactUtils.classNames)('private-close__button', SIZE_CLASSES[size], className, {
          'private-close__button--disabled': disabled
        }),
        'data-action': 'close',
        disabled: disabled,
        onClick: onClick,
        style: _extends({
          color: color
        }, style)
      }),
      this.renderCloseIcon(color),
      _react2.default.createElement(
        'span',
        { className: 'sr-only' },
        _I18n2.default.text('salesUI.UICloseButton.label')
      )
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/button/UICloseButton.js
// module id = 230
// module chunks = 0 1